import { Home, Layers, Clipboard, RefreshCcw, BookOpen, Users, FileText, Heart, MessageSquare, Shield, Settings, LogOut, Target, CreditCard, HelpCircle, UserCheck, Building2Icon, Send, Globe } from 'lucide-react';

export const FEATURE_MAP = {
  'Add Group': 'multiple_groups_management',
  'Members': 'members_management',
  'Contribution': 'manual_contribution_management',
  'Shares': 'shares_management',
  'Loan Types': 'advanced_loan_management',
  'Member Loans': 'advanced_loan_management',
  'Merry Go Round': 'merry_go_round_automation',
  'Meeting Notes': 'meeting_minutes',
  'Meetings': 'meetings',
  'Documents': 'documents_management',
  'Bulk SMS': 'bulk_sms',
  'Contribute via M-Pesa': 'mpesa_paybill_integration',
  'Welfare': 'welfare_management',
  'Add Fine': 'fine_management',
  'Admin Management': 'multiple_groups_management',
  'Expenses': 'expenses_management',
};

// Navigation features matching the original Layout.js structure
export const navigationFeatures = [
  // Main section - keep original structure
  {
    code: 'dashboard',
    label: 'Dashboard',
    path: '/',
    icon: Home,
    section: 'main',
    alwaysShow: true
  },
  {
    code: 'transactions',
    label: 'Transactions',
    path: '/transactions',
    icon: CreditCard,
    section: 'main',
    alwaysShow: true
  },
  {
    code: 'disbursement',
    label: 'Disbursement',
    path: '/disbursement',
    icon: CreditCard,
    section: 'main',
    apiFeature: 'money_disbursement',
    adminOnly: true
  },
  {
    code: 'members',
    label: 'Members',
    path: '/members',
    icon: Users,
    section: 'main',
    apiFeature: 'members_management',
    adminOnly: true
  },
  {
    code: 'documents',
    label: 'Documents',
    path: '/documents',
    icon: FileText,
    section: 'main',
    apiFeature: 'documents_management'
  },
  {
    code: 'subgroups',
    label: 'Subgroups',
    path: '/subgroups',
    icon: Layers,
    section: 'main',
    adminOnly: true,
    hasDropdown: true,
    dropdownItems: [
      {
        code: 'subgroups-categories',
        label: 'Subgroups / Categories',
        path: '/subgroups?tab=subgroups',
        icon: Layers
      },
      {
        code: 'subgroups-villages',
        label: 'Villages / Regions',
        path: '/subgroups?tab=villages',
        icon: Globe
      }
    ]
  },
  {
    code: 'my-subgroup',
    label: 'My Subgroup',
    path: '/my-subgroup',
    icon: Layers,
    section: 'main'
  },
  {
    code: 'houses',
    label: 'Houses',
    path: '/houses',
    icon: Building2Icon,
    section: 'main',
    adminOnly: true
  },
  {
    code: 'my-house',
    label: 'My House',
    path: '/my-house',
    icon: Home,
    section: 'main'
  },
  
  // Contributions section - comprehensive dropdown
  {
    code: 'contributions',
    label: 'Contribution',
    path: '/contributions',
    icon: RefreshCcw,
    section: 'contributions',
    apiFeature: 'manual_contribution_management'
  },
  {
    code: 'contribution-drives',
    label: 'Contribution Drives',
    path: '/contribution-drives',
    icon: Target,
    section: 'contributions',
    apiFeature: 'manual_contribution_management',
    adminOnly: true
  },
  {
    code: 'shares',
    label: 'Shares',
    path: '/shares',
    icon: Shield,
    section: 'contributions',
    apiFeature: 'shares_management'
  },
  {
    code: 'merry-go-round',
    label: 'Merry Go Round',
    path: '/merry-go-round',
    icon: RefreshCcw,
    section: 'contributions',
    apiFeature: 'merry_go_round_automation'
  },
  {
    code: 'welfare',
    label: 'Welfare',
    path: '/welfare',
    icon: Heart,
    section: 'contributions',
    apiFeature: 'welfare_management'
  },
  {
    code: 'fines',
    label: 'Fines',
    path: '/fines',
    icon: Shield,
    section: 'contributions',
    apiFeature: 'fine_management',
    adminOnly: true
  },
  {
    code: 'expenses',
    label: 'Expenses',
    path: '/expenses',
    icon: CreditCard,
    section: 'main',
    apiFeature: 'expenses_management',
    adminOnly: true
  },
  
  // Meetings section - new dropdown structure
  {
    code: 'meetings',
    label: 'Meetings',
    path: '/meetings',
    icon: Clipboard,
    section: 'meetings',
    apiFeature: 'meetings'
  },
  {
    code: 'meeting-notes',
    label: 'Meeting Notes',
    path: '/meeting-notes',
    icon: BookOpen,
    section: 'meetings',
    apiFeature: 'meeting_minutes'
  },

  //Assets
  {
    code:'Assets',
    label:'Assets',
    path:'/assets',
    icon: Building2Icon,
    section:'main',
    apiFeature:'asset_management',
    adminOnly:false
  },
  
  // Loans section - keep original structure
  {
    code: 'loan-types',
    label: 'Loan Types',
    path: '/loan-types',
    icon: Shield,
    section: 'loans',
    apiFeature: 'advanced_loan_management',
    adminOnly: true
  },
  {
    code: 'member-loans',
    label: 'Member Loans',
    path: '/member-loans',
    icon: Shield,
    section: 'loans',
    apiFeature: 'advanced_loan_management'
  },
  {
    code: 'table-banking-loans',
    label: 'TableBanking Loans',
    path: '/table-banking-loans',
    icon: Shield,
    section: 'loans',
    apiFeature: 'advanced_loan_management'
  },
  {
    code: 'loan-disbursements',
    label: 'Loan Disbursements',
    path: '/loan-disbursements',
    icon: Shield,
    section: 'loans',
    apiFeature: 'advanced_loan_management',
    adminOnly: true
  },
  {
    code: 'loan-arrears',
    label: 'Loan Arrears',
    path: '/loan-arrears',
    icon: Shield,
    section: 'loans',
    apiFeature: 'advanced_loan_management',
    adminOnly: true
  },
  {
    code: 'loan-fees',
    label: 'Loan Fees',
    path: '/loan-fees',
    icon: Shield,
    section: 'loans',
    apiFeature: 'advanced_loan_management',
    adminOnly: true
  },
  {
    code: 'loan-approvals',
    label: 'Loan Approvals',
    path: '/loan-approvals',
    icon: Shield,
    section: 'loans',
    apiFeature: 'advanced_loan_management',
    adminOnly: true
  },
  // {
  //   code: 'loan-approval-dashboard',
  //   label: 'Approval Dashboard',
  //   path: '/loan-approval-dashboard',
  //   icon: Shield,
  //   section: 'loans',
  //   apiFeature: 'basic_loan_management',
  //   adminOnly: true
  // },
  // Moved to Settings > Loans tab
  // {
  //   code: 'loan-settings',
  //   label: 'Loan Settings',
  //   path: '/loan-settings',
  //   icon: Settings,
  //   section: 'loans',
  //   apiFeature: 'basic_loan_management',
  //   adminOnly: true
  // },
  // {
  //   code: 'table-banking-settings',
  //   label: 'Table Banking Settings',
  //   path: '/table-banking-settings',
  //   icon: Settings,
  //   section: 'loans',
  //   apiFeature: 'basic_loan_management',
  //   adminOnly: true
  // },
  {
    code: 'loan-eligibility',
    label: 'Check Eligibility',
    path: '/loan-eligibility',
    icon: Shield,
    section: 'loans',
    apiFeature: 'advanced_loan_management',
    memberOnly: true
  },
  {
    code: 'guarantor-requests',
    label: 'Guarantor Requests',
    path: '/guarantor-requests',
    icon: Users,
    section: 'loans',
    apiFeature: 'advanced_loan_management'
  },
  
  // Admin section - keep original structure

  {
    code: 'sms',
    label: 'SMS',
    path: '/bulk-sms',
    icon: MessageSquare,
    section: 'admin',
    apiFeature: 'bulk_sms',
    adminOnly: true,
    hasDropdown: true,
    dropdownItems: [
      {
        code: 'bulk-sms',
        label: 'Bulk SMS',
        path: '/bulk-sms',
        icon: Send
      },
      {
        code: 'sms-logs',
        label: 'Sent System Messages',
        path: '/sms-logs',
        icon: MessageSquare
      }
    ]
  },
  {
    code: 'admin-management',
    label: 'Admin Management',
    path: '/admins',
    icon: Users,
    section: 'admin',
    apiFeature: 'multiple_admin_access',
    adminOnly: true,
    hasDropdown: true,
    dropdownItems: [
      {
        code: 'admins',
        label: 'Admins',
        path: '/admins',
        icon: Users
      },
      {
        code: 'roles',
        label: 'Roles',
        path: '/roles',
        icon: Shield
      }
    ]
  },
  
  // Settings section - moved documentation here
  {
    code: 'settings',
    label: 'Settings',
    path: '/settings',
    icon: Settings,
    section: 'settings',
    alwaysShow: true
  },
  {
    code: 'documentation',
    label: 'Documentation',
    path: '/documentation',
    icon: HelpCircle,
    section: 'settings',
    alwaysShow: true
  },
  {
    code: 'context-switch',
    label: 'Switch Context',
    path: '#',
    icon: UserCheck,
    section: 'settings',
    isAction: true,
    groupAdminOnly: true
  },
  {
    code: 'logout',
    label: 'Logout',
    path: '#',
    icon: LogOut,
    section: 'settings',
    isAction: true,
    alwaysShow: true
  }
]; 